import React, { useState } from "react";
import axios from "axios";
import assets from "../../../../../assets/assets";
import styled from "styled-components";
import {
  IconController,
  LottieController,
} from "../../../../Scripts/ImgController";
import { useAxiosConfigGlobal, EmailHeader } from "../../../../Config/axios";
import Ripples from "react-ripples";
import HttpConfirmation from "../../HttpConfirmation";
import { apiURL } from "../../../../Config/url";
const Wrapper = styled.div`
  input[type="text"] {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px;
    font-size: 12px;
    font-weight: 600;
  }
`;
const AddressSection = ({
  setCKPopup,
  setCKPopupType,
  setCKPopupMessage,
  isUserCanEdit,
  oneRingRulesAll,
}) => {
  const PublisherInformation = JSON.parse(
    localStorage.getItem("Current-Publisher")
  );
  const [editable, setEditable] = useState(false);
  const axiosConfig = useAxiosConfigGlobal;
  const [emailData, setEmailData] = useState(EmailHeader);

  const [countryValue, setCountryValue] = useState("");
  const [cityValue, setCityValue] = useState("");
  const [locationValue, setLocationValue] = useState("");

  const [countryChanged, setCountryChanged] = useState(false);
  const [cityChanged, setCityChanged] = useState(false);
  const [locationChanged, setLocationChanged] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const attr1 = {
    field: "Улс",
    value: {
      old: PublisherInformation?.address_country,
      new: countryValue,
    },
  };
  const attr2 = {
    field: "Хот",
    value: {
      old: PublisherInformation?.address_city,
      new: cityValue,
    },
  };
  const attr3 = {
    field: "Байршил",
    value: {
      old: PublisherInformation?.address,
      new: locationValue,
    },
  };

  const setCountryHandler = (value) => {
    setCountryValue(value);
    setCountryChanged(true);
  };
  const setCityHandler = (value) => {
    setCityValue(value);
    setCityChanged(true);
  };
  const setLocationHandler = (value) => {
    setLocationValue(value);
    setLocationChanged(true);
  };

  const cancelHandler = () => {
    setEditable(false);
    setCountryValue("");
    setCityValue("");
    setLocationValue("");
    setCountryChanged(false);
    setCityChanged(false);
    setLocationChanged(false);
  };

  const requestHandler = async () => {
    setRequestSent(true);
    await axios
      .post(apiURL + "notifications/panel/emails", emailData, axiosConfig)
      .then((res) => {
        if (res.status === 200) {
          emailData.attributes.length = 0;
          setCKPopupType("Success");
          setCKPopupMessage("changeRequestSuccess");
          setCKPopup(true);
          setRequestSent(false);
          cancelHandler();
        }
      })
      .catch((err) => {
        setRequestSent(false);
        if (err.response.status === 401) {
          oneRingRulesAll("logout");
        }
      });
  };

  return (
    <Wrapper className="border-CK ">
      <h5 className="font-bold text-sm pb-9">Хаяг байршил</h5>
      {editable ? (
        <>
          {requestSent ? (
            <div
              className="absolute top-0 left-0 w-full h-full  rounded-xl"
              style={{ background: "#a9b7d280" }}
            >
              <div className="w-full h-full flex flex-row justify-center items-center">
                <LottieController
                  src={assets.lottie.loadingLottie}
                  className="w-32 h-32 flex flex-row justify-center"
                />
              </div>
            </div>
          ) : (
            ""
          )}
          {requestSent ? (
            ""
          ) : (
            <div className="absolute top-4 right-4 ">
              <div className="flex flex-row gap-2">
                <Ripples color="#0061FF40" during={600} className="rounded-2xl">
                  <div
                    className="cancel-button"
                    onClick={() => {
                      cancelHandler();
                    }}
                  >
                    <div className="flex flex-row justify-center items-center px-3">
                      <h5 className="text-xs font-medium py-2 pr-1">Болих</h5>
                      <IconController
                        src={assets.svg.informationCancel}
                        className="h-4 w-4"
                      />
                    </div>
                  </div>
                </Ripples>
                <Ripples color="#ffffff40" during={600} className="rounded-2xl">
                  <div
                    className="confirm-button"
                    onClick={() => {
                      emailData.attributes.length = 0;
                      if (countryChanged || cityChanged || locationChanged) {
                        if (countryChanged) {
                          emailData.attributes.push(attr1);
                        }
                        if (cityChanged) {
                          emailData.attributes.push(attr2);
                        }
                        if (locationChanged) {
                          emailData.attributes.push(attr3);
                        }
                        setConfirmation(true);
                      } else {
                        setCKPopupType("Info");
                        setCKPopupMessage("nothingChanged");
                        setCKPopup(true);
                      }
                    }}
                  >
                    <div className="flex flex-row justify-center items-center px-3">
                      <h5 className="text-xs font-medium py-2 pr-1">
                        Өөрчлөх хүсэлт илгээх
                      </h5>
                      <IconController
                        src={assets.svg.requestMail}
                        className="h-4 w-4"
                      />
                    </div>
                  </div>
                </Ripples>
              </div>
            </div>
          )}
          <div className="flex flex-row flex-wrap">
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">Улс</h5>
              <input
                type="text"
                onChange={(e) => {
                  setCountryHandler(e.target.value);
                }}
                placeholder={PublisherInformation?.address_country}
              />
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">Хот</h5>
              <input
                type="text"
                onChange={(e) => {
                  setCityHandler(e.target.value);
                }}
                placeholder={PublisherInformation?.address_city}
              />
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">Байршил</h5>
              <input
                type="text"
                onChange={(e) => {
                  setLocationHandler(e.target.value);
                }}
                placeholder={PublisherInformation?.address}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-row flex-wrap">
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">Улс</h5>
              <h5 className="font-semibold text-xs">
                {PublisherInformation?.address_country}
              </h5>
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">Хот</h5>
              <h5 className="font-semibold text-xs">
                {PublisherInformation?.address_city}
              </h5>
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">Байршил</h5>
              <h5 className="font-semibold text-xs">
                {PublisherInformation?.address}
              </h5>
            </div>
          </div>
          {isUserCanEdit ? (
            <div className="edit-button">
              <Ripples color="#0061FF40" during={600} className="rounded-2xl">
                <div
                  className="flex flex-row justify-center items-center px-3"
                  onClick={() => {
                    setEditable(true);
                  }}
                >
                  <h5 className="text-xs font-medium py-2 pr-1">Засах</h5>
                  <IconController
                    src={assets.svg.editIcon}
                    className="h-4 w-4"
                  />
                </div>
              </Ripples>
            </div>
          ) : (
            ""
          )}
        </>
      )}
      {confirmation ? (
        <HttpConfirmation
          yesFunc={requestHandler}
          data={emailData}
          noFunc={setConfirmation}
        />
      ) : (
        ""
      )}
    </Wrapper>
  );
};

export default AddressSection;
